// src/components/AvantageGroupeRabais.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

/**
 * Petite note accolée aux bannières « Inscription de groupe » (Accueil,
 * Formations, fiche d'une formation) : le code rabais, attribué par
 * l'Académie quand elle confirme la session du groupe (voir
 * groupeOrganismeController.approuverGroupeOrganisme), varie selon le nombre
 * d'apprenants inscrits — pas un pourcentage fixe promis d'avance.
 *
 * `surFondRouge` : à passer quand la note est affichée À L'INTÉRIEUR de la
 * bannière rouge (Accueil, Formations) plutôt que sur le fond clair de la
 * page (fiche d'une formation) — seules les couleurs du texte changent.
 */
const AvantageGroupeRabais = ({ sx, surFondRouge = false }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      textAlign: 'center',
      flexWrap: 'wrap',
      ...sx,
    }}
  >
    <LocalOfferIcon sx={{ fontSize: '1.1rem', color: surFondRouge ? '#ffd54f' : '#f57f17', flexShrink: 0 }} />
    <Typography
      variant="body2"
      sx={{
        color: surFondRouge ? 'rgba(255,255,255,0.88)' : '#8a5a00',
        fontSize: '0.85rem',
        fontWeight: 500,
      }}
    >
      <strong style={surFondRouge ? { color: '#ffd54f' } : undefined}>Avantage groupe :</strong>{' '}
      un code rabais peut être offert à votre organisme, selon le nombre d'apprenants inscrits.
    </Typography>
  </Box>
);

export default AvantageGroupeRabais;
